enum MutationTypeEnum {
	attributes = 'attributes',
	characterData = 'characterData',
	childList = 'childList'
}

export default MutationTypeEnum;
